import { flowToolEvent } from '../teamAgent/teamAgentService';
import { getMyIpAgentRoomId } from './agentBinding';
import { getMyIpMediaUrl } from './mediaUrl';
import { getMyIpDetailMedia } from './detailMedia';
import { omitMyIpProfileMaterials } from './resourceSlots';
import type { MyIpItem } from './types';

/** 按 Agent IPDetail 协议构造快照；封面使用展示 URL，不把资产 ID 当地址。 */
function characterSnapshot(item: MyIpItem): Record<string, unknown> {
  const media = getMyIpDetailMedia(item);
  return JSON.parse(JSON.stringify({
    name: item.name,
    summary: item.summary,
    version: item.version,
    cover_url: media.coverUrl || getMyIpMediaUrl(item.coverAssetId) || '',
    avatar_url: '',
    profile: omitMyIpProfileMaterials(item.profile),
    resources: item.resources.map((resource) => ({
      id: resource.id,
      asset_id: resource.assetId,
      url: resource.url,
      resource_role: resource.role,
      resource_type: resource.type,
      sort_order: resource.sortOrder,
    })),
  }));
}

/** 仅由手动保存成功入口调用；事件不幂等，上报失败不能重试或让已保存主档再次提交。 */
export async function reportMyIpManualEdit(before: MyIpItem, after: MyIpItem, signal?: AbortSignal): Promise<void> {
  if (signal?.aborted) return;
  try {
    if (before.ipId !== after.ipId) throw new Error('IP event identity changed');
    const roomId = getMyIpAgentRoomId(before);
    if (after.sourceSessionId !== undefined && after.sourceSessionId !== roomId) throw new Error('IP event room changed');
    const previous = characterSnapshot(before);
    const next = characterSnapshot(after);
    // 版本推进本身不代表角色内容变化，但实际事件的 before/after 都携带各自版本。
    if (JSON.stringify({ ...previous, version: 0 }) === JSON.stringify({ ...next, version: 0 })) return;
    await flowToolEvent(roomId, {
      operations: [{
        resource_type: 'ip_character',
        action: 'update',
        ip_character: { ip_id: before.ipId, before: previous, after: next },
      }],
    }, signal);
  } catch (error) {
    if (!signal?.aborted) console.error('[reportMyIpManualEdit] Agent context update failed', error);
  }
}
